module.exports = __webpack_public_path__ + "img/hanging-found-illustration.f14fdf02.svg";